module.exports = __webpack_public_path__ + "img/logo.12547acc.png";